// 3rd party imports
import * as React from 'react';

// mobx
import { Program } from 'models';

// ui
import { UitkFigure, UitkImage, UitkFigureAspectRatioType } from 'uitk-react-images';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export interface ProgramCardLogoProps {
  program: Program;
}

export const ProgramCardLogo: React.FunctionComponent<ProgramCardLogoProps> = ({ program }) => {
  return (
    <UitkFigure ratio={UitkFigureAspectRatioType.R21_9} className="affiliate-hub-brand-logo">
      <UitkImage alt={program.name} src={program.img} />
    </UitkFigure>
  );
};
